var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-indicator c-indicator--clickable icon-clear-data s-status-caution"},[_c('span',{staticClass:"label c-indicator__label"},[_c('button',{on:{"click":_vm.globalClearEmit}},[_vm._v("Clear Data")])])])}
var staticRenderFns = []

export { render, staticRenderFns }